// import qrcodeImg from '../assets/home/qrcode-full.png'
// import './log-envent.js'
import Toast from './toast'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import {
  DASHBOARD_LIST,
  HTTP_STATUS,
  MAX_REQ_TIMEOUTS,
  STORAGE_KEY,
  WHITE_LIST,
  VALID_URL
} from './consts'
// import beforePage from './before-page'
// import { initLogs, initRum, setUser } from './datalog'
import i18n, { getApiErrorCodes } from '../lang'
import { addRequest, removeRequest, saveRequest, isPageUnloading } from './requestManager'
import { getActivePinia } from 'pinia'
import { useUploadStore } from '../models/stores/upload/useUploadStore'

dayjs.extend(utc)
dayjs.extend(customParseFormat)

const t = i18n.global.t

const isLocal = location.hostname.includes('localhost') || location.hostname.includes('192.168')
const DEV_BASE_URL = isLocal ? process.env.BASE_URL : '/'

// hide console.log in production and test
if (process.env.ENV === 'prod' || process.env.ENV === 'test') {
  console.log = function () {}
}

const baseRequest = async (url, data) => {
  return await fetch(`${DEV_BASE_URL}${url}`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json'
    },
    body: data ? JSON.stringify(data) : null
  })
}

const isInDashboard = DASHBOARD_LIST.some(path => location.pathname.includes(path))
const isScanatWebOrIDPages = [
   ...DASHBOARD_LIST, 
  'models.html',
  'landing.html',
  'login.html',
  'register.html',
  'reset-password.html'].some(path => location.pathname.includes(path))
const isInWhiteList =
  WHITE_LIST.includes(location.pathname) || location.pathname.startsWith('/articles/')
const redirect = (modelKey = '') => {
  localStorage.removeItem(STORAGE_KEY.LOGIN_TIME)
  if (isInWhiteList) {
    return
  }
  if (modelKey) {
    window.location.href = '/login.html'
    sessionStorage.setItem('SCANAT_SHARE_LINK', location.href)
  }
  window.location.href = '/login.html'
}

const showHttpStatus = async (response, url = '', options = {}) => {
  let res = { code: 0, message: '' }
  const contentType = response.headers.get('content-type')
  if (contentType && contentType.indexOf('application/json') !== -1) {
    res = await response.clone().json()
  }

  const status = HTTP_STATUS.find(
    status =>
      status.code === response.status
  )
  const errStatus = getApiErrorCodes(url).find(
    status => response.status === 200 && res?.code === status.code
  )
  if (status) {
    if (location.pathname.includes('models.html')) {
      return true
    } else {
      if (url.includes('portal/cards') && status.code === 500) return
      new Toast().toast('warning', t(status.message) || res?.message , false, {
        delay: 5000,
        callback: () => {
          const redirectUrl = sessionStorage.getItem(STORAGE_KEY.REDIRECT_URL)
          if (redirectUrl) {
            window.location.href = redirectUrl
            sessionStorage.removeItem(STORAGE_KEY.REDIRECT_URL)
          }
        }
      })

      return { handled: true, shouldRetry: false }
    }
  }
  if (response.status === 200 && res?.code === 873 && !location.href.includes('modelId') && !isModelKey()) {
    if (location.pathname.includes('models.html')) {
      window.dispatchEvent(
        new CustomEvent('scanat:model-deleted', {
          detail: {
            type: url.includes('models/list') ? 'access' : 'operation'
          }
        })
      )
    }
  }

  if (isScanatWebOrIDPages) {
    if (errStatus) {
      if(errStatus.noToast) {
        return { handled: false, shouldRetry: false }
      }
      if (url.includes('portal/cards') && errStatus.code === 500) {
        return { handled: true, shouldRetry: false }
      }
      if (url.includes('portal/customer/domain') && options.method === 'PUT' && errStatus.code === 781) {
        new Toast().toast('warning', t('error.comInfoDomain'))
        return { handled: true, shouldRetry: false }
      }
      if (errStatus.code === 866 && url.includes('folders/refresh')) {
        new Toast().toast('danger', t(errStatus.message))
        return { handled: false, shouldRetry: false }
      }
      new Toast().toast('danger', t(errStatus.message))
      return { handled: true, shouldRetry: false }
    }
  }

  const isCode401 = response.status === 401 || res?.code === 401
  const isLogin = Boolean(localStorage.getItem(STORAGE_KEY.LOGIN_TIME))
  const isModelShared = isModelKey()

  const isHomeAuthed = isCode401 && isInWhiteList && isLogin
  const isOtherAuthed = isCode401 && !isInWhiteList
  const refreshToken = localStorage.getItem('SCANAT_REFRESH_TOKEN')
  if (isCode401) {
    const tokenRes = await baseRequest('auth/refresh_token', {
      refreshToken,
      isFromPortal: true
    })
    const curTokenRes = await tokenRes.json()
    const isTokenUpdated = tokenRes.status === 200 && curTokenRes?.code === 200
    if (isTokenUpdated) {
      localStorage.setItem('SCANAT_TOKEN', curTokenRes.data.access_token)
      localStorage.setItem('SCANAT_REFRESH_TOKEN', curTokenRes.data.refresh_token)
      // 已刷新 token，交由上层重新发起原请求
      return { handled: true, shouldRetry: true }
    }
    // 401: Unauthorized
    if (isHomeAuthed || isOtherAuthed) {
      const msg =
        (tokenRes.status !== 200 || curTokenRes?.code !== 200)
          ? 'セキュリティ上の理由で、Scanat Webでは複数端末からの同時ログインはできません。アカウントが自動的にログアウトされました。再度ログインしてください。'
          : 'セッションの有効期限が切れました。再度ログインしてください。'

      let isValid = isModelShared
      if (isValid) {
        if (VALID_URL.find(path => url.includes(path))) {
          return { handled: false, shouldRetry: false }
        }
      }
      if (!isValid) {
        if (tokenRes.status === 400 || curTokenRes?.code === 400) {
          redirect()
          return { handled: true, shouldRetry: false }
        }
        new Toast().toast('warning', t('error.overDue'), false, {
          callback: () => {
            redirect()
          }
        })
        throw new Error('Unauthorized') 
      }
      return { handled: true, shouldRetry: false }
    }
  }
  

  return { handled: false, shouldRetry: false }
}

const request = (
  url,
  data = {},
  isNeedToken = true,
  method = 'POST',
  isNeedResponse = false,
  customHeaders = {
    'Content-Type': 'application/json'
  }
) => {
  const existingPromise = addRequest(url, method, data)
  if (existingPromise) {
    return existingPromise
  }

  const controller = AbortController ? new AbortController() : null

  const promise = (async () => {
    // check network status
    if (!navigator.onLine) {
      const pinia = getActivePinia()
      if (!pinia || !useUploadStore(pinia).isUploading) {
        new Toast().toast('warning', t('error.checkNetWork'), false, {
          delay: 5000
        })
      }
      removeRequest(url, method, data)
      throw new Error('No network connection')
    }

    const createOptions = () => {
      const headers = {
        ...customHeaders
      }

      if (isNeedToken) {
        const token = localStorage.getItem('SCANAT_TOKEN')
        if (token) {
          headers['Authorization'] = `Bearer ${token}`
        }
      }

      const options = {
        method,
        headers,
        mode: 'cors'
      }

      if (controller) {
        options.signal = controller.signal
      }

      if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
        if (data instanceof FormData) {
          options.body = data
          delete options.headers['Content-Type']
        } else if (data) {
          options.body = JSON.stringify(data)
        }
      }

      return options
    }

    const buildUrl = () => {
      if (url.startsWith('http') || url.startsWith('https')) {
        return url
      }
      if (method === 'GET' && data) {
        return `${DEV_BASE_URL}${url}?${new URLSearchParams(data).toString()}`
      }
      return `${DEV_BASE_URL}${url}`
    }

    const timeoutKey = Object.keys(MAX_REQ_TIMEOUTS).find(key => url.includes(key)) || 'default'
    let hasRetried = false

    const performFetch = async (isRetry = false) => {
      const fetchUrl = buildUrl()
      const options = createOptions()
      const timeout = setTimeout(() => controller?.abort('timeout'), MAX_REQ_TIMEOUTS[timeoutKey])

      try {
        const response = await fetch(fetchUrl, options)
        clearTimeout(timeout)

        const statusResult = await showHttpStatus(response, url, options)
        if (statusResult.shouldRetry && !hasRetried) {
          hasRetried = true
          return await performFetch(true)
        }
        if (statusResult.handled) {
          return
        }

      if (isNeedResponse) {
        return response
      }

      const res = await response.json()

        return res
      } catch (err) {
        clearTimeout(timeout)

        if (err.name === 'AbortError' || controller?.signal?.aborted) {
          if (controller?.signal?.reason === 'timeout') {
            new Toast().toast(
              'warning',
              t('error.timeOut'),
              false,
              {
                delay: 5000
              }
            )
          } else {
            console.log('request cancelled:', url)
          }
          throw new Error(controller?.signal?.reason || 'cancelled')
        }

        if (isPageUnloading()) {
          throw new Error('cancelled')
        }

        throw err
      } finally {
        removeRequest(url, method, data)
      }
    }

    return await performFetch()
  })()

  if (navigator.onLine) {
    saveRequest(url, method, data, promise, controller)
  }

  return promise
}

function escapeHtml(str) {
  return String(str ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

const toUTCTime = (time, format) => {
  return dayjs(time).utc().format(format)
}

const toLocalTime = (
  time,
  currentFormat = 'YYYY-MM-DD HH:mm:ss',
  targetFormat = 'YYYY-MM-DD HH:mm'
) => {
  if (!time) {
    return ''
  }
  return dayjs(dayjs.utc(time, currentFormat)).tz(dayjs.tz.guess()).format(targetFormat)
}

const formatDateTime = (dateTime, template = 'YYYY-MM-DD HH:mm') => {
  if (!dateTime) {
    return '—'
  }

  return dayjs.utc(dateTime).local().format(template)
}

// Format money: 1000000 => 1,000,000
const formatMoney = money => {
  if (!money) return 0
  return '￥' + money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const isMobile = () => window.innerWidth < 768

const formatEmailDisplay = email => {
  //  add new line every 26 characters
  const characters = (email || '').split('')
  for (let i = 26; i < characters.length; i += 26) {
    characters[i] = characters[i] + '\n'
  }

  return characters.join('')
}

const disablePaginationItem = className => {
  const el = document.querySelector(`.${className}`)
  el.firstChild.setAttribute('disabled', '')
  el.classList.add('opacity-40')
  el.firstChild.style.pointerEvents = 'none'
}

const genPagination = (data, newData, loadList) => {
  const { total, pages } = data
  // generate pagination
  const paginationEl = document.querySelector('.pagination')
  const totalEl = document.querySelector('.pagination-total')
  totalEl.textContent = `総計 ${total} 件`

  if (pages >= 1) {
    paginationEl.innerHTML =
      '<li class="page-item page-first"><a class="page-link" href="#">最初のページ</a></li>' +
      '<li class="page-item page-divider" style="color:#00365b33">|</li>' +
      '<li class="page-item page-prev"><a class="page-link" href="#">前へ</a></li>'

    for (let i = 1; i <= pages; i++) {
      const liEl = document.createElement('li')
      liEl.classList.add('page-item', 'page-number')

      if (i === Number(newData.page)) {
        liEl.classList.add('active')
      }

      // add gap
      if (i !== pages) {
        liEl.style.marginRight = '0.5rem'
      }
      liEl.style.backgroundColor = '#0068B014'

      const aEl = document.createElement('a')
      aEl.classList.add('page-link')
      aEl.style.color = '#0068B099'

      aEl.href = '#'
      aEl.textContent = i
      liEl.appendChild(aEl)
      paginationEl.appendChild(liEl)
    }
    paginationEl.innerHTML +=
      '<li class="page-item page-next"><a class="page-link" href="#">次へ</a></li>' +
      '<li class="page-item page-divider" style="color:#00365b33">|</li>' +
      '<li class="page-item page-last"><a class="page-link" href="#">最終ページ</a></li>'

    if (pages === 1) {
      const classes = ['page-prev', 'page-next', 'page-first', 'page-last']
      classes.forEach(className => {
        disablePaginationItem(className)
      })
    }

    // only show 5 pages mostly
    // format page item to 1,2,...,length-1,length
    if (pages > 5) {
      const cursor = Number(newData.page)
      let validPages = [cursor, cursor + 1, cursor + 2, cursor + 3, cursor + 4, cursor + 5]
      let centerPage = cursor + 4
      if (cursor > pages - 5) {
        validPages = [pages - 5, pages - 4, pages - 3, pages - 2, pages - 1, pages]
        centerPage = pages - 6
      }

      const pageItems = document.querySelectorAll('.page-number')
      const pageItemsArr = Array.from(pageItems)
      pageItemsArr.forEach((item, index) => {
        if (!validPages.includes(index + 1)) {
          item.style.display = 'none'
        }

        if (index === centerPage) {
          item.querySelector('a').textContent = '…'
          item.querySelector('a').style.paddingLeft = '9px'
          item.querySelector('a').style.paddingRight = '9px'
          item.firstChild.setAttribute('disabled', '')
          item.firstChild.style.pointerEvents = 'none'
        }
      })
    }

    if (newData.page === 1) {
      disablePaginationItem('page-prev')
      disablePaginationItem('page-first')
    }

    if (newData.page === pages) {
      disablePaginationItem('page-next')
      disablePaginationItem('page-last')
    }

    paginationEl.onclick = e => {
      e.preventDefault()

      if (e.target.tagName === 'A') {
        const classes = e.target.parentElement.classList
        let currentPage = Number(e.target.textContent)

        if (classes.contains('page-first')) {
          currentPage = 1
        }

        if (classes.contains('page-prev')) {
          currentPage = newData.page
          currentPage--

          if (currentPage < 1) {
            currentPage = 1
          }
        }

        if (classes.contains('page-next')) {
          currentPage = newData.page
          currentPage++

          if (currentPage > pages) {
            currentPage = pages
          }
        }

        if (classes.contains('page-last')) {
          currentPage = pages
        }

        loadList({
          ...newData,
          page: currentPage
        })
      }
    }

    const jumpPageEl = document.querySelector('.pagination-jump')
    if (jumpPageEl) {
      jumpPageEl.value = newData.page
      jumpPageEl.onchange = e => {
        let jumpPage = e.target.value
        if (jumpPage > pages) {
          jumpPage = pages
        }

        if (jumpPage < 1) {
          jumpPage = 1
        }

        loadList({
          ...newData,
          page: jumpPage
        })
      }
    }
  }
}

const hasWhiteSpace = s => /\s/g.test(s)

const isEmail = email => /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}$/.test(email)

const isDomain = domain => /^(?:(?:[a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+)(?:\.[a-zA-Z]{2,})+$/.test(domain)

const queryAWSAccessHeader = (method, param, json) => {
  const payload = {
    method: method,
    host: 'https://image.scanat.app',
    path: process.env.ENV === 'prod' ? '/prod/image' : '/dev/image',
    payload: json
  }

  if (param) {
    payload.path = payload.path + '?' + 'key' + '=' + param
  }

  return request('aws/access/header', payload)
}

const queryDownloadURL = (queryString, key) => {
  const host = process.env.ENV === 'prod' ? 'https://image.scanat.app' : 'https://image.scanat.app'
  let path = process.env.ENV === 'prod' ? '/prod/image' : '/dev/image'
  path = path + '?' + 'key' + '=' + key + '&' + queryString

  return host + path
}

const isModelKey = () => {
  const { type, modelKey = false } = parseShareLink() || {}
  return modelKey
}

const parseShareLink = () => {
  const params = new URLSearchParams(location.search)
  const modelKey = params.get('modelKey')

  if (modelKey && /.{8}-.{4}-.{4}-.{4}-.{12}/.test(modelKey)) {
    return {
      type: 'new',
      modelKey: modelKey
    }
  }
  const searchValue = location.search.split('?')
  // model key is 36 characters,like 0049a868-31bc-44cd-923b-2e820920050b
  // get model key from search value use regex
  // ignore other search value like &cn&autoload
  const oldFormatKey = searchValue.find(value => value.match(/.{8}-.{4}-.{4}-.{4}-.{12}/))
  if (oldFormatKey && location.pathname.includes('models.html')) {
    return {
      type: 'old',
      modelKey: oldFormatKey
    }
  }
  return null
}

const checkModelKey = async (isNeedToken = true) => {
  const modelKey = isModelKey()
  if (!modelKey) return true
  const token = localStorage.getItem('SCANAT_TOKEN')
  const res = await request(
    `webModels/share/authorization?key=${modelKey}`,
    null,
    isNeedToken,
    'GET'
  )
  const isValid = res && res.code === 200 && res.data
  if (res.code === 401 && token) {
    localStorage.removeItem('SCANAT_TOKEN')
    return checkModelKey(false)
  }
  if (!isValid && !localStorage.getItem('SCANAT_TOKEN')) {
    sessionStorage.setItem('SCANAT_SHARE_LINK', location.href)
    redirect(modelKey)
  }
  return isValid
}

const checkAccountActive = async () => {
  try {
    const authRes = await request('auth/currentUserInfo', null, true, 'POST')
    if (authRes?.code === 200) {
      const userInfo = authRes.data
      if([0, 6].includes(userInfo?.userStatus)) {
        new Toast().toast('warning', t('error.accountDisable'), false, {
          above: true,
          callback: () => {
            localStorage.removeItem('SCANAT_TOKEN')
            localStorage.removeItem('SCANAT_REFRESH_TOKEN')
            window.location.href = '/login.html'
          }
        })
        throw new Error('accountDisable')
      }
      sessionStorage.setItem('SCANAT_USER_INFO', JSON.stringify(authRes.data))
      return {
        isActive: [1].includes(userInfo?.userStatus),
        isNoPortalAdmin: ![1,2,3].includes(userInfo?.isPortalAdmin),
        isWebpermission: userInfo?.webPermission === 1,
        userInfo: { ...authRes.data }
      }
    }
    return {
      isActive: false,
      isNoPortalAdmin: false,
      isWebpermission: false,
      userInfo: {}
    }
  } catch (error) {
    console.log(error, 'error')
    if (error.message.includes('cancelled')) {
      return {
        isCancelled: true
      }
    }
    if (error.message.includes('accountDisable')) {
      throw new Error('accountDisable')
    }
    return {
      isActive: null,
      isNoPortalAdmin: false,
      isWebpermission: false,
      userInfo: {}
    }
  }
}

const toDataURL = url =>
  fetch(url)
    .then(response => response.blob())
    .then(
      blob =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        })
    )

const showNoPermissionModal = () => {
  const noPermissionModalEl = document.querySelector('#noPermissionModal')
  if (noPermissionModalEl) {
    new mdb.Modal(noPermissionModalEl).show()
  }
}

const userInfoInterval = () => {
  // set timer to get user info every 1 minute
  setInterval(async () => {
    await request('auth/currentUserInfo')
  }, 30000)
}
const adaptDevice = ({ systemSource, device } = {}) => {
  if (device) {
    if (systemSource === 3) return device.replace(/[^a-zA-Z].*$/, '') || '-'
    let name = ''
    let version = ''
    if (/Edg\//i.test(device)) {
      name = 'Microsoft Edge'
      const match = device.match(/Edg\/([\d.]+)/)
      version = match ? match[1] : ''
    } else if (/Firefox\//i.test(device)) {
      name = 'Firefox'
      const match = device.match(/Firefox\/([\d.]+)/)
      version = match ? match[1] : ''
    } else if (/OPR\//i.test(device)) {
      name = 'Opera'
      const match = device.match(/OPR\/([\d.]+)/)
      version = match ? match[1] : ''
    } else if (/Chrome\//i.test(device)) {
      name = 'Chrome'
      const match = device.match(/Chrome\/([\d.]+)/)
      version = match ? match[1] : ''
    } else if (/Safari\//i.test(device) && !/Chrome|Edg/i.test(device)) {
      name = 'Safari'
      const match = device.match(/Version\/([\d.]+)/)
      version = match ? match[1] : ''
    } else if (/MSIE|Trident/i.test(device)) {
      name = 'Internet Explorer'
      const msieMatch = device.match(/MSIE ([\d.]+)/)
      if (msieMatch) {
        version = msieMatch[1]
      } else {
        const rvMatch = device.match(/rv:([\d.]+)/)
        version = rvMatch ? rvMatch[1] : ''
      }
    }
    if (name) {
      return name
    }
    return device
  }
  return '-'
}

const formatFileSize = (size, shouldFormat = false) => {
  if (!size) {
    return size
  }
  let num = ''
  let unit = ''
  const units = ['KB', 'M', 'G']
  units.forEach(loopUnit => {
    if (size.includes(loopUnit)) {
      num = size.split(loopUnit)[0]
      if (shouldFormat && num) {
        num = num.replace(/,/g, '')
      }
      unit = loopUnit
    }
  })
  const formattedNum = shouldFormat
    ? Math.round(Number(num)).toLocaleString('en-US')
    : Math.round(Number(num))
  return formattedNum + unit
}

const formatFileSizeNum = size => {
  if (!size) return size
  if (size < 1024) return `${size}B`
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`
  if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(2)} MB`
  return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`
}

/**
 * 检查用户是否可以访问服务
 * @param {Object} customerRes - 客户信息
 * @param {planData} planData - 套餐信息
 * @returns {Promise<Object>} { canAccess, message } - 是否可访问及提示消息
 */
const checkCustomerAccess = async () => {
  const linkEle = `<span style="cursor: pointer" href="javascript:;" onclick="window.open('/admin.html#/payment', '_blank')">${t(
    'order.purchaseNow'
  )} <i class='fs-6 iconfont icon-icon_universe_circle_right'></i></span>`
  const result = await checkAccountActive()
  if (result.isCancelled) {
    return { canAccess: true, message: null }
  }
  if (result.isActive === null) {
    return { canAccess: false, message: null }
  }
  const { isActive, isWebpermission, userInfo = {}, userInfo: { useSeat = 0 } = {} } = result
  const { customerPlan } = userInfo
  const customers = JSON.parse(sessionStorage.getItem('customer') || '{}')

  if (isActive === false) {
    return {
      canAccess: false,
      message: t('error.accountDisable')
    }
  }
  // 检查客户ID是否存在
  if (!userInfo?.customerId) {
    return {
      canAccess: false,
      message: `${t('error.noPlan')} ${linkEle}`,
      closeable: true
    }
  }

  if (userInfo.isPortalAdmin === 4) {
    return {
      canAccess: false,
      message: `${t('error.noRight')}`,
    }
  }

  const isAdmin = [1, 2, 3].includes(userInfo.isPortalAdmin)
  const { status = 0, goodsName, startTime, endTime, goods } = customerPlan || {}
  const isContainerScanatWeb = isWebpermission || [1, 2].includes(goods?.supportPlatform)
  const planEndTime = formatDateTime(endTime, 'YYYY.MM.DD')
  const planStartTime = formatDateTime(startTime, 'YYYY.MM.DD')
  const messageMap = {
    // 管理员消息映射
    admin: {
      0: { canAccess: false, message: `${t('error.noPlan')} ${linkEle}`, closeable: true },
      3: {
        canAccess: false,
        message: `${t('error.overDate', { plan: goodsName, date: planEndTime })}${linkEle}`,
        closeable: true
      },
      1: {
        true: {
          canAccess: false,
          message: `${t('error.unactive', { plan: goodsName, date: planStartTime })}`
        },
        false: { canAccess: false, message: `${t('error.noService')}` }
      },
      2: {
        true: {
          1: { canAccess: true, message: null },
          0: { canAccess: false, message: `${t('error.noRight')}` }
        },
        false: {
          canAccess: false,
          message: `${t('error.noService')}`,
          callback: showNoPermissionModal
        }
      }
    },
    // 普通用户消息映射
    user: {
      0: { canAccess: false, message: `${t('error.noService')}` },
      3: { canAccess: false, message: `${t('error.noService')}` },
      1: {
        true: {
          canAccess: false,
          message: `${t('error.unactive', { plan: goodsName, date: planStartTime })}`
        },
        false: { canAccess: false, message: `${t('error.noService')}` }
      },
      2: {
        true: {
          1: { canAccess: true, message: null },
          0: { canAccess: false, message: `${t('error.noRight')}` }
        },
        false: { canAccess: false, message: `${t('error.noService')}` }
      }
    }
  }

  // 获取用户类型
  const userType = isAdmin ? 'admin' : 'user'
  if (status === 2 ) {
    if(isContainerScanatWeb) {
      return messageMap[userType][status][isContainerScanatWeb][useSeat]
    } else {
      return messageMap[userType][status][isContainerScanatWeb]
    } 
  }
  if (status === 1) {
    return messageMap[userType][status][isContainerScanatWeb]
  } 

  // 处理其他status情况
  return messageMap[userType][status] || { canAccess: true, message: null }
}

// 下载文件通用方法
const downloadFile = async (url, data, type, filename) => {
  try {
    const res = await request(url, data, true, 'GET', true)
    const result = await res.blob()
    const blob = new Blob([result], { type: type })

    if (window.navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename)
    } else {
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      setTimeout(() => {
        URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      }, 100)
    }
    return true
  } catch (error) {
    console.error('Download failed:', error)
    return false
  }
}
const createAndClickAnchor = (url, target, fileName) => {
  if (!url) {
    console.error('URL cannot be empty');
    return;
  }
  const link = document.createElement('a');
  link.href = url;
  
  if (fileName) {
    link.download = fileName; 
  }
  
  if (target) {
    link.target = target;
  }
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click()
  document.body.removeChild(link);
}

const getRootFontSize = () => {
  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  return rootFontSize || 16;
}

const palette = [
  {start: [124, 178, 210], end: [174, 228, 255]},
  {start: [110, 119, 203], end: [160, 169, 253]},
  {start: [180, 110, 203], end: [230, 160, 253]},
  {start: [99, 172, 138], end: [149, 222, 188]},
  {start: [194, 165, 61], end: [244, 215, 111]},
  {start: [203, 136, 110], end: [253, 186, 160]},
  {start: [203, 136, 110], end: [253, 186, 160]},
  {start: [110, 203, 200], end: [160, 253, 250]},
  {start: [194, 132, 56], end: [244, 182, 106]},
  {start: [203, 110, 161], end: [253, 160, 211]},
  {start: [125, 79, 44], end: [175, 129, 94]},
  {start: [202, 61, 64], end: [252, 111, 114]},
  {start: [110, 73, 162], end: [160, 123, 212]},
  {start: [133, 161, 97], end: [183, 211, 147]},
  {start: [76, 194, 114], end: [126, 244, 164]},
  {start: [49, 106, 213], end: [99, 156, 255]}
];
const hashString = (value) => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
    hash |= 0;
  }
  return Math.abs(hash);
};
const clamp = (value) => Math.max(0, Math.min(255, value));
const adjustRgb = (rgb, delta) => rgb.map(channel => clamp(channel + delta));
const toRgbString = (rgb) => `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
const getUserColor = (item = {}) => {
  if (!item.surname || !item.name) return '#7cb2d2';
  const [localPart = 'user', domainPart = 'scanat.com'] = item.email?.trim?.().toLowerCase().split('@');
  const localHash = hashString(localPart);
  const domainHash = hashString(domainPart);
  const mixedHash = hashString(`${localPart}|${domainPart}`);
  const base = palette[mixedHash % palette.length];
  const startAdjust = (localHash % 24) - 12;
  const endAdjust = (domainHash % 24) - 12;
  const reverse = mixedHash % 2 === 0;
  const startColor = toRgbString(adjustRgb(base.start, startAdjust));
  const endColor = toRgbString(adjustRgb(base.end, endAdjust));
  return reverse
    ? `linear-gradient(135deg, ${endColor} 0%, ${startColor} 100%)`
    : `linear-gradient(135deg, ${startColor} 0%, ${endColor} 100%)`;
};

const getUserName = (item = {}, isFull = false) => {
  if (!item.surname || !item.name) return isFull ? t('common.unNamed') : '';
  if (isFull) return `${item.surname} ${item.name}`;
  return /^[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\uFF65-\uFF9F]+$/u.test(item.surname)
    ? item.surname
    : `${item.surname[0]}${item.name[0]}`;
};
const sleep = (ms = 0) => new Promise(resolve => setTimeout(resolve, ms))

export {
  DEV_BASE_URL,
  request,
  escapeHtml,
  formatDateTime,
  toLocalTime,
  toUTCTime,
  formatMoney,
  isMobile,
  genPagination,
  formatEmailDisplay,
  hasWhiteSpace,
  isEmail,
  isDomain,
  queryAWSAccessHeader,
  queryDownloadURL,
  isModelKey,
  parseShareLink,
  checkModelKey,
  toDataURL,
  isLocal,
  userInfoInterval,
  isInDashboard,
  checkAccountActive,
  adaptDevice,
  formatFileSize,
  formatFileSizeNum,
  checkCustomerAccess,
  downloadFile,
  sleep,
  getRootFontSize,
  getUserColor,
  getUserName,
  createAndClickAnchor
}
